import React from 'react';
import { Link } from 'react-router-dom';

export const columns = [
  {
    column: {
      Header: 'Edit',
      accessor: 'id',
      width: 50,
      resizable: true,
      filterable: false,
      Cell: (props: any) => (
        <Link to={`/Admin/editUser/${props.value}`}>
          <i className='fa fa-edit' />
        </Link>
      ),
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Name',
      accessor: 'name',
      width: 400,
      resizable: true,
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Email',
      accessor: 'emailAddress',
      width: 400,
      resizable: true,
    },
    type: 'string',
  },
  {
    column: {
      Header: 'AD ID',
      accessor: 'adId',
      width: 400,
      resizable: true,
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Active',
      accessor: 'active',
      filterable: false,
      width: 350,
      resizable: true,
      Cell: (props: any) => (props.value ? <i className='fas fa-check'></i> : null),
    },
    type: 'string',
  },
];
